import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { Skeleton, Select as MuiSelect } from '@mui/material';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import toast from 'react-hot-toast';
import { MdOutlineModeEdit } from "react-icons/md";
import { HiOutlineRefresh } from 'react-icons/hi';
import ComingSoonTab from './components/ComingSoonTab';
import DetailsTab from './components/DetailsTab';
import ImagesTab from './components/ImagesTab';
import PurchaseOrderTab from './components/PurchaseOrderTab';
import BackordersTab from './components/BackordersTab';
import PicklistsTab from './components/PicklistsTab';
import ReservationsTab from './components/ReservationsTab';
import ProductHistory from './components/ProductHistory';
import WarehouseModal from './components/WarehouseModal';
import ChangeStockModal from './components/ChangeStockModal';
import NoImage from 'assets/images/no-image.png';
import usePageTitle from 'hooks/usePageTitle';
import { Dropdown } from 'react-bootstrap';
import { LuChevronDown } from 'react-icons/lu';
import useIsMobile from 'utils/isMobileUtils';
import ReactSelect from 'react-select';
import ChangeStockModalMobile from './components/ChangeStockModalMobile';




// ✅ Clear
const ProductView = () => {
	const [setPageTitle] = usePageTitle('Products');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const { id } = useParams();
	const [activeComponent, setActiveComponent] = useState('Details');
	const [isDisable, setDisable] = useState(false);
	const [openWarehousePopup, setOpenWarehousePopup] = useState(false);
	const [changeStockPopup, setChangeStockPopup] = useState(false);
	const history = useNavigate();
	const [productDetails, setProductDetails] = useState();
	const [defaultThumbnail, setDefaultThumbnail] = useState('');
	const [customThumbnail, setCustomThumbnail] = useState('');
	const [isLoading, setIsloading] = useState(true);
	const [isDisabled, setIsDisabled] = useState(true);
	const [currentStatus, setCurrentStatus] = useState(false);
	const [currentPortalStatus, setCurrentPortalStatus] = useState(false);

	const [show, setShow] = useState('');


	const getProductDetails = () => {
		setIsloading(true);
		api.getProductDetails(id).then((res) => {
			setIsloading(false);
			setIsDisabled(false)
			setProductDetails(res.data);
			setCustomThumbnail(res.data?.custom_thumbnail?.thumbnail);
			res?.data?.thumbnails?.map((thumbnail) => {
				if (thumbnail?.is_default == 1) {
					setDefaultThumbnail(thumbnail?.thumbnail_url);
				}
			});
			if (res?.data?.status == 1) {
				setCurrentStatus(true);
			} else {
				setCurrentStatus(false);
			}
			if (res?.data?.in_portal == 1) {
				setCurrentPortalStatus(true);
			} else {
				setCurrentPortalStatus(false);
			}
		});
	};

	const onHandleLoadProductDetails = () => {
		getProductDetails();
	}
	
	const handleClose = () => setShow('');

	const handleDelete = (item) => {

		toast.promise(api.deleteModelProduct(item).then((res) => {
			if (res.status) {
				setProductDetails(oldData => ({ ...oldData, products: oldData?.products?.filter(p => p?.id != item) }));
			}

			setShow(null);

			return res?.status ? res : abc;
		}), {
			loading: 'Deleting Product...',
			success: (data) => `${data.message}`,
			error: <b>Failed to delete product</b>
		})
	};

	const handleComponentChange = (component) => {
		setActiveComponent(component);
	};

	const openModalFormWarehouse = () => {
		setOpenWarehousePopup(true);
	}

	const closePopup = () => {
		setOpenWarehousePopup(false);
	};
	const closechagePopup = () => {
		setChangeStockPopup(false);
	}

	const handleSave = (data) => {
		toast.promise(
			api
				.assignProductWarehouse({
					product_id: data.productId,
					warehouse_id: data.warehouseId,
				})
				.then((res) => {
					setDisable(false);
					if (res.status) {
						setOpenWarehousePopup(false);
						getProductDetails();
					}
					return res?.status ? res : null;
				}),
			{
				loading: 'Updating Warehouse...',
				success: (data) => `${data.message}`,
				error: <b>Failed to assign product warehouse</b>
			}
		);
	}
	const changeStocks = (data) => {

		toast.promise(
			api
				.changeStock(data)
				.then((res) => {
					closechagePopup();
					getProductDetails();

					return res?.status ? res : null;
				}),
			{
				loading: 'Updating Warehouse Stocks...',
				success: (data) => `${data.message}`,
				error: <b>Failed to change stock</b>
			}
		);
	}


    const allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
    const validateFileExtension = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        return allowedExtensions.includes(extension);
    };

	
	const handleFileUpload = (e) => {
		const files = e;
		if (files && files.length > 0) {
			const formData = new FormData();
			for (let i = 0; i < files.length; i++) {
				formData.append('thumbnail_files[]', files[i]);
			}
			formData.append('product_id', productDetails?.id);

			api.uploadProductImage(productDetails?.id, formData).then((res) => {
				setProductDetails(oldData => ({ ...oldData, thumbnails: res.data?.thumbnails }));

				res?.data?.thumbnails?.map((thumbnail) => {
					if (thumbnail?.is_default == 1) {
						setDefaultThumbnail(thumbnail?.thumbnail_url);
					}
				});
			});
		}
	};

	const deleteThumbnail = (thumbnailId) => {
		toast.promise(
			api
				.deleteProductThumbnail(thumbnailId)
				.then(
					(res) => {
						if (res.status) {
							setProductDetails(oldData => ({ ...oldData, thumbnails: res.data }));

							res?.data?.map((thumbnail) => {
								if (thumbnail?.is_default == 1) {
									setDefaultThumbnail(thumbnail?.thumbnail_url);
								}
							});
						}

						return res?.status ? res : null;
					},
					() => {
						// setIsSubmitDisabled(false);
					}
				),
			{
				loading: 'Updating Products...',
				success: (data) => `${data.message}`,
				error: <b>Failed to update products</b>
			}
		);
	}

	const handleDeleteThumbnail = () => {
		const thumbnailId = show;
		toast.promise(
			api
				.deleteProductThumbnail(thumbnailId)
				.then(
					(res) => {
						if (res.status) {
							setProductDetails(oldData => ({ ...oldData, thumbnails: res.data }));

							res?.data?.map((thumbnail) => {
								if (thumbnail?.is_default == 1) {
									setDefaultThumbnail(thumbnail?.thumbnail_url);
								}
							});
						}
						setShow('');

						return res?.status ? res : null;
					},
					() => {
					}
				),
			{
				loading: 'Updating Products...',
				success: (data) => `${data.message}`,
				error: <b>Failed to update products</b>
			}
		);
	}

	const handleSetDefaultThumbnail = (thumbnailId) => {

		let thumbnailFormData = {
			product_id: productDetails?.id,
			thumbnail_id: thumbnailId
		};

		toast.promise(
			api
				.setProductDefaultThumbnail(id, thumbnailFormData)
				.then(
					(res) => {
						if (res.status) {
							setProductDetails(oldData => ({ ...oldData, thumbnails: res.data }));

							res?.data?.map((thumbnail) => {
								if (thumbnail?.is_default == 1) {
									setDefaultThumbnail(thumbnail?.thumbnail_url);
								}
							});
						}

						return res?.status ? res : null;
					},
					() => {
						// setIsSubmitDisabled(false);
					}
				),
			{
				loading: 'Updating Products...',
				success: (data) => `${data.message}`,
				error: <b>Failed to update products</b>
			}
		);

	}
	const changeStock = () => {
		setChangeStockPopup(true);
	}

	const handleChangeType = (type) => {

		// 1 => Normal; 2 => Unlimited stock; 3 => Virtual composition; 4 => Composition with own stock

		let paramValue = '';
		let paramType = 'product-type';
		let msg = 'product type';
		if (type == 'status') {
			paramValue = productDetails?.status ? 0 : 1;
			paramType = 'status'
			msg = 'status'
		} else if (type == 'portal') {
			paramValue = productDetails?.in_portal ? 0 : 1;
			paramType = 'portal'
			msg = 'portal status'
		} else if (type == 'unlimited-stock') {
			paramValue = 2;
		} else if (type == 'virtual-composition') {
			paramValue = 3;
		} else if (type == 'virtual-composition-stock') {
			paramValue = 4;
		} else {
			return false;
		}
		toast.promise(
			api
				.changeProductType({
					product_id: productDetails?.id,
					type: paramType,
					param: paramValue
				})
				.then((res) => {
					getProductDetails();

					return res?.status ? res : null;
				}),
			{
				loading: `Changing ${msg}...`,
				success: (data) => `${data.message}`,
				error: <b>Failed to change {msg}</b>
			}
		);
	}
	useEffect(() => {
		getProductDetails();
	}, []);

	const isMobile = useIsMobile();

	return (
		<>
			<div className="row">
				<div className="col-12">
					<div className="row pb10">
						<div className="col-12">
							<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
								<div className="header-bubble" />
								<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
									<div
										style={{
											position: 'relative',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											minHeight: 38 // ensures enough height for the button
										}}
									>
										{' '}
										<button
											type="button"
											aria-label="Back"
											onClick={() => history(-1)}
											className="circle-back-btn"
											style={{
												position: 'absolute',
												left: 20,
												top: '50%',
												transform: 'translateY(-50%)'
											}}
										>
											{/* Replace with your fi arrow icon, example below */}
											<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
												<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
										</button>
										<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{productDetails?.product_name}</h5>
									</div>
									<PermissionAllowed permissions={['Edit Model Details (Action)']}>
										<div className="horizontal-scroll" style={{ paddingLeft: 20, paddingRight: 20 }}>
											<div>
												<Dropdown className="product-view-change-type iconbtn" align={'end'}>
													<Dropdown.Toggle as="span">
														<Link
															to={''}
															className={
																isDisabled
																	? 'btn btn-primary btn-outlined-main white-var disabled'
																	: 'btn btn-primary btn-outlined-main white-var'
															}
															disabled={isDisabled}
															style={{ minWidth: 'unset' }}
														>
															Change Type <LuChevronDown />
														</Link>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item
															onClick={() => {
																handleChangeType('status');
															}}
														>
															Make product {currentStatus ? 'inactive' : 'active'}
														</Dropdown.Item>
														<Dropdown.Item
															onClick={() => {
																handleChangeType('portal');
															}}
														>
															Make product {currentPortalStatus ? 'inactive' : 'active'} to portal
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</div>

											<button
												className={isDisabled ? 'bulk-action btn-outlined-main  disabled' : 'bulk-action btn-outlined-main '}
												disabled={isDisabled}
												onClick={() => changeStock()}
											>
												<HiOutlineRefresh />
											</button>
											<button
												className={isDisabled ? 'bulk-action btn-outlined-main  disabled' : 'bulk-action btn-outlined-main '}
												disabled={isDisabled}
												onClick={() => history(`/products/edit/${productDetails?.id}`)}
											>
												<MdOutlineModeEdit />
											</button>
										</div>
									</PermissionAllowed>
								</div>
							</div>
							<div className="section-head hide-on-mobile">
								{
									isLoading ? ( 
										<div style={{ margin: '-5px auto -5px -10px' }}>
											<Skeleton variant="rounded" width={200} height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px' }}>{productDetails?.sku}</h2>
									)
								}
								
								<div className="actions">
									{
										isLoading ? ( 
											<>
												<div >
													<Skeleton variant="rounded" width={100} height={30} style={{ borderRadius: '32px' }} />
												</div>
												<div >
													<Skeleton variant="rounded" width={100} height={30} style={{ borderRadius: '32px' }} />
												</div>
												<div >
													<Skeleton variant="rounded" width={100} height={30} style={{ borderRadius: '32px' }} />
												</div>
											</>
										) : (
											<PermissionAllowed permissions={['Edit Model Details (Action)']}>
												<div>
													<Dropdown className="product-view-change-type iconbtn" align={'end'}>
														<Dropdown.Toggle as="span">
															<Link
																to={''}
																className={
																	isDisabled
																		? 'btn btn-primary btn-outlined-main white-var disabled'
																		: 'btn btn-primary btn-outlined-main white-var'
																}
																disabled={isDisabled}
																style={{ minWidth: 'unset' }}
															>
																Change Type <LuChevronDown />
															</Link>
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item
																onClick={() => {
																	handleChangeType('status');
																}}
															>
																Make product {currentStatus ? 'inactive' : 'active'}
															</Dropdown.Item>
															<Dropdown.Item
																onClick={() => {
																	handleChangeType('portal');
																}}
															>
																Make product {currentPortalStatus ? 'inactive' : 'active'} to portal
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</div>

												<button
													className={isDisabled ? 'bulk-action btn-outlined-main  disabled' : 'bulk-action btn-outlined-main '}
													disabled={isDisabled}
													onClick={() => changeStock()}
												>
													<HiOutlineRefresh /> Change Stock
												</button>
												<button
													className={isDisabled ? 'bulk-action btn-outlined-main  disabled' : 'bulk-action btn-outlined-main '}
													disabled={isDisabled}
													onClick={() => history(`/products/edit/${productDetails?.id}`)}
												>
													<MdOutlineModeEdit /> Edit
												</button>
											</PermissionAllowed>
										)
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row mobile-scroll-container">
				<div className="col-12">
					<div className={`${isMobile ? ' ' : 'card p-2'}`}>
						<div className={`content ${isMobile ? '' : 'pad15'}`}>
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-md-2 col-sm-3 col-12">
									{
										isLoading ? (
											<div style={{ width: '90px' }}>
												<Skeleton variant="rounded" width={'100%'} height={'100px'} style={{ borderRadius: '12px' }} />
											</div>
										) : (
											defaultThumbnail ? (
												<img src={defaultThumbnail} className="product-thumbnail" alt="product" style={{ marginLeft: '10px' }} />
											) : customThumbnail ? (
												<img src={customThumbnail} className="product-thumbnail" alt="product" style={{ marginLeft: '10px' }} />
											) : (
												<img src={NoImage} alt="product" style={{ width: '70px', height: '100px' }} />
											)	
										)
									}
								</div>
								<div className="col-md-8 col-sm-9 col-12 product-header-summary">
									<div className="row">
										<div className="col-12">
											<div className="row form-group">
												<div className="col-12">
													<div className="form-section mb-2">
														<div className=" font16">
															{
																isLoading ? (
																	<div className="mb-2">
																		<Skeleton variant="rounded" width={150} height={20} style={{ borderRadius: '12px' }} />
																	</div>
																) : (
																	<h4 className="font18">
																		<b>
																			{productDetails?.product_name}
																		</b>
																	</h4>
																)
															}
														</div>
													</div>
													<div className="row product-preview-stock-labels">
														<div className="col-12 font13 ">
															{
																isLoading ? ( 
																	<div className="">
																		<Skeleton variant="rounded" width={100} height={25} style={{ borderRadius: '12px' }} />
																	</div>
																) : (
																	<div className="">
																		<div className={`badge2 badge-light-gray2`} style={{ fontWeight: '500', color: '#000' }}>
																			{productDetails?.sku ?? 'No SKU'}
																		</div>
																	</div>
																)
															}
														</div>
													</div>
													<div className="row">
														<div className="col-12 product-stock-summary">
															<div className="stock-list">
																<div className="row">
																	<div className="col-md-12 font13">
																		{
																			isLoading ? ( 
																				<div>
																					<Skeleton variant="rounded" width={100} height={20} style={{ borderRadius: '12px' }} />
																				</div>
																			) : (
																				<>
																					<span className="textGray">Total Stock</span>
																					<span className="font500 text-primary">: {productDetails?.stocks?.total}</span>
																				</>
																			)
																		}
																	</div>
																</div>
															</div>
															<div className="stock-list">
																<div className="row">
																	<div className="col-md-12 font13">
																		{
																			isLoading ? ( 
																				<div>
																					<Skeleton variant="rounded" width={100} height={20} style={{ borderRadius: '12px' }} />
																				</div>
																			) : (
																				<>
																					<span className="textGray">Reserved</span>
																					<span className="font500 text-primary">: {productDetails?.stocks?.reserved}</span>
																				</>
																			)
																		}
																	</div>
																</div>
															</div>
															<div className="stock-list">
																<div className="row">
																	<div className="col-md-12 font13">
																		{
																			isLoading ? ( 
																				<div>
																					<Skeleton variant="rounded" width={100} height={20} style={{ borderRadius: '12px' }} />
																				</div>
																			) : (
																				<>
																					<span className="textGray">Stocks Needed</span>
																					<span className="font500 text-primary">: {productDetails?.stocks?.stock_needed}</span>
																				</>
																			)
																		}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="show-on-mobile">
								<div style={{ display: 'flex', marginBottom: '10px', gap: 10 }}>
									<img
										src={defaultThumbnail ? defaultThumbnail : customThumbnail ? customThumbnail : NoImage}
										alt="product"
										style={{
											width: 'auto',
											height: '150px',
											maxWidth: '120px',
											objectFit: 'contain',
											borderRadius: 8,
											background: '#f8f8f8'
										}}
									/>
									<div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
										<h4 className="fw500" style={{ fontSize: 16, marginBottom: 0 }}>
											{productDetails?.product_name}
										</h4>
										<div style={{ display: 'flex' }}>
											<div style={{ padding: '5px 10px', background: 'rgb(240 239 239)', borderRadius: 8, fontSize: 12 }}>
												SKU: {productDetails?.sku ?? 'No SKU'}
											</div>
										</div>
										<div style={{ display: 'flex', gap: 5, fontSize: 12 }}>
											<div className="">Total Stock:</div>
											<div className="" style={{ color: '#316aff' }}>
												{productDetails?.stocks?.total}
											</div>
										</div>
										<div style={{ display: 'flex', gap: 5, fontSize: 12 }}>
											<div className="">Reserved:</div>
											<div className="" style={{ color: '#316aff' }}>
												{productDetails?.stocks?.reserved}
											</div>
										</div>
										<div style={{ display: 'flex', gap: 5, fontSize: 12 }}>
											<div className="">Stocks Needed:</div>
											<div className="" style={{ color: '#316aff' }}>
												{productDetails?.stocks?.stock_needed}
											</div>
										</div>
									</div>
								</div>
							</div>

							{isMobile ? (
								<div style={{ margin: '16px 0' }}>
									<ReactSelect
										value={{
											value: activeComponent,
											label: {
												Details: 'Details',
												StockHistory: 'Stock history',
												PurchaseOrders: 'Purchase orders',
												Images: 'Images',
												Backorders: 'Backorders',
												Reservations: 'Reservations',
												Picklists: 'Picklists',
												// Log: 'Log'
											}[activeComponent]
										}}
										onChange={(option) => !isLoading && handleComponentChange(option.value)}
										options={[
											{ value: 'Details', label: 'Details' },
											{ value: 'StockHistory', label: 'Stock history' },
											{ value: 'PurchaseOrders', label: 'Purchase orders' },
											{ value: 'Images', label: 'Images' },
											{ value: 'Backorders', label: 'Backorders' },
											{ value: 'Reservations', label: 'Reservations' },
											{ value: 'Picklists', label: 'Picklists' },
											// { value: 'Log', label: 'Log' }
										]}
										isDisabled={isLoading}
										styles={{
											control: (base, state) => ({
												...base,
												background: '#f5f5f5',
												borderColor: '#e0e0e0',
												minHeight: 38,
												borderRadius: 8,
												boxShadow: state.isFocused ? '0 0 0 1px #bdbdbd' : base.boxShadow,
												color: '#333'
											}),
											singleValue: (base) => ({
												...base,
												color: '#333'
											}),
											menu: (base) => ({
												...base,
												zIndex: 9999
											})
										}}
										isSearchable={false}
									/>
								</div>
							) : (
									
									isLoading ? ( 
										<div className="flex gap-3">

											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={80} height={20} style={{ borderRadius: '32px' }} />
											</div>
										</div>
								) : (
									
									<ul className="topListCom">
										<li
											className={`fw-400 ${activeComponent === 'Details' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('Details');
											}}
										>
											Details
										</li>
										<li
											className={`fw-400 ${activeComponent === 'StockHistory' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('StockHistory');
											}}
										>
											Stock history
										</li>
										<li
											className={`fw-400 ${activeComponent === 'PurchaseOrders' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('PurchaseOrders');
											}}
										>
											Purchase orders
										</li>
										<li
											className={`fw-400 ${activeComponent === 'Images' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('Images');
											}}
										>
											Images
										</li>
										<li
											className={`fw-400 ${activeComponent === 'Reservations' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('Reservations');
											}}
										>
											Reservations
										</li>
										<li
											className={`fw-400 ${activeComponent === 'Backorders' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('Backorders');
											}}
										>
											Backorders
										</li>
										<li
											className={`fw-400 ${activeComponent === 'Picklists' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
											onClick={() => {
												!isLoading && handleComponentChange('Picklists');
											}}
										>
											Picklists
										</li>
									</ul>
								)
							)}

							{activeComponent === 'Details' ? (
								<DetailsTab
									productDetails={productDetails}
									openModalFormWarehouse={openModalFormWarehouse}
									isLoading={isLoading}
								/>
							) : activeComponent == 'StockHistory' ? (
								<ProductHistory productDetails={productDetails} />
							) : activeComponent == 'PurchaseOrders' ? (
								<PurchaseOrderTab productDetails={productDetails} />
							) : activeComponent == 'Reservations' ? (
								<ReservationsTab
									productDetails={productDetails}
									handleLoadProductDetails={onHandleLoadProductDetails}
								/>
							) : activeComponent == 'Images' ? (
								<ImagesTab
									productDetails={productDetails}
									handleFileUpload={handleFileUpload}
									deleteThumbnail={deleteThumbnail}
									handleSetDefaultThumbnail={handleSetDefaultThumbnail}
								/>
							) : activeComponent == 'Backorders' ? (
								<BackordersTab
									productDetails={productDetails}
								/>
							) : activeComponent == 'Picklists' ? (
								<PicklistsTab
									productDetails={productDetails}
								/>
							) : activeComponent == 'Log' ? (
								<ComingSoonTab />
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
			{!!show && (
				<DeleteConfirmation
					show={show}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete ${show?.name}`}
				/>
			)}
			{openWarehousePopup && (
				<WarehouseModal
					openWarehousePopup={openWarehousePopup}
					productDetails={productDetails}
					handleClose={closePopup}
					handleSave={handleSave}
					disableStatus={isDisable}
				/>
			)}

			{changeStockPopup && !isMobile && (
				<ChangeStockModal
					openChangestockPopup={changeStockPopup}
					productDetails={productDetails}
					handleClose={closechagePopup}
					handleSave={changeStocks}
					disableStatus={isDisable}
				/>
			)}

			{changeStockPopup && isMobile && (
				<ChangeStockModalMobile
					openChangestockPopup={changeStockPopup}
					productDetails={productDetails}
					handleClose={closechagePopup}
					handleSave={changeStocks}
					disableStatus={isDisable}
				/>
			)}
		</>
	);
};

export default ProductView;
